<template>
  <popup-dialog
    :visible="visible"
    class="member-invitationpopup"
    :close-button-visible="true"
    :title="memberWord == 'user' ? $t('actions.inviteUsers') : $t('actions.inviteMembers')"
    @close="$emit('close')"
  >
    <member-invitation-form
      v-if="visible"
      :invite-function="inviteFunction"
      :member-word="memberWord"
      v-bind="$attrs"
      class="member-invitationpopup__main"
      @invited="$emit('close')"
    >
      <template #header>
        <slot></slot>
      </template>
    </member-invitation-form>
  </popup-dialog>
</template>

<script setup lang="ts">

import PopupDialog from "@core/ui/PopupDialog.vue";
import MemberInvitationForm from "./MemberInvitationForm.vue";

defineOptions({
  inheritAttrs: false
});

type ListEntry = {
  user: { email: string };
  validUntil?: string;
  roleCode?: string;
};

const {
  inviteFunction,
  visible = false,
  memberWord = "member",
} = defineProps<{
  inviteFunction: (entries: ListEntry[]) => Promise<unknown>;
  visible?: boolean;
  memberWord?: "member" | "user";
}>();

const emit = defineEmits(["close"]);
</script>

<style lang="scss">
.member-invitationpopup {
  overflow: auto;

  &__main {
    padding: 2rem;
    padding-top: 3rem;
  }
}
</style>
